<div class="product-header-container">
  <div class="container">
    <div class="row product-header bg-gray">
      <div class="col-60">
        <h2 class="text-uppercase product-subtitle">{{subtitle}}</h2>
        <h1 class="text-uppercase elsa-title-font product-title">{{title}}</h1>
        <div class="d-flex flex-column flex-lg-row align-items-lg-end justify-content-lg-between w-100">
          <h3 class="product-phi-info mb-0">{{phyInfo}}</h3>
          <h4 class="product-description-header" *ngIf="description2">
            {{description2}}
          </h4>
        </div>
      </div>
      <div class="col-60 d-lg-none">
        <div class="position-relative">
          <div class="d-flex flex-row justify-content-center position-absolute w-100 product-image-header-container">
            <img [src]="img" class="product-image-header" *ngIf="img"
                 [alt]="title">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div class="row">
    <div class="col-60 col-lg-38 product-description" [innerHTML]="description | safeHtml"></div>
    <div class="col-22 d-none d-lg-flex">
      <div class="product-image-container">
        <img [src]="img" class="product-image mb-5" *ngIf="img"
             [alt]="title">
      </div>
    </div>
  </div>
</div>
